var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('pageHeader'),_c('video',{ref:"video",attrs:{"autoplay":"","playsinline":""}}),_c('canvas',{ref:"canvas",attrs:{"width":"640","height":"480"}}),(_vm.isPoseDetected)?_c('div',{staticClass:"alert"},[_vm._v(" 检测到目标姿势！已截图。 ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }